// Thin host wrapper — Slip Archive. Tier-gated to sika_pro
// (PRD §3.2 / INTEGRATION_PATCH §7): the page renders the
// TierLockedTeaser when the user is below Sika Pro, otherwise the
// real (honest-empty until slips settle) archive.
import { useNavigate } from "react-router-dom";
import { useUserTier } from "../../auth/useUserTier.ts";
import { tierMeets } from "../../auth/tier-gates.ts";
import { useIntlAccaArchive } from "../../intl-acca/useIntlAccaArchive.ts";
import { SlipArchivePage } from "./SlipArchivePage.tsx";

export function IntlAccaArchiveRoute(): JSX.Element {
  const navigate = useNavigate();
  const { tierCode } = useUserTier();
  const vm = useIntlAccaArchive();
  return (
    <SlipArchivePage
      loading={vm.loading}
      error={vm.error}
      rows={vm.rows}
      hasAccess={tierMeets(tierCode, "sika_pro")}
      onOpenSlip={(slipId) => navigate(`/intl-acca/slip/${slipId}`)}
      onUpgrade={() => navigate("/pricing")}
    />
  );
}
